import AdminQueueSidebar from './AdminQueueSidebar';

export default AdminQueueSidebar;
